<template>
	<section class="container-add-user">
		<div class="pessoas-container">
			<div class="container-tables">
				<div class="table-box">
					<h1 class="title-pessoas">Produtos:</h1>
					<div class="search-container">
						<Search width="70%" height="35px" @searchText="searchtext" />
					</div>
					<b-table
						v-if="data.length > 0"
						:data="myData"
						:columns="columns"
						:checked-rows.sync="checkedRows"
						checkable
						paginated
						per-page="5"
						pagination-size="is-small"
					/>
				</div>
				<div class="table-box">
					<h1 class="title-pessoas">Produtos Selecionados:</h1>
					<div>
						<draggable v-model="checkedRows" class="draggable" v-bind="dragOptions">
							<div
								v-for="(row, index) in checkedRows"
								:key="index"
								class="animate__animated animate__fadeInRight box-item-selected"
							>
								<a class="menu-row-option" @click="removeItem(row.integracao_id, index)">
									<feather class="menu-row-icon danger" type="trash" size="16" />
								</a>
								ID:{{ ' ' + row.produto_id }}<br />
								Integração ID: {{ ' ' + row.integracao_id }} <br />
								Produto: {{ ' ' + row.descricao }}
								<b-field grouped>
									<b-field label="Data inicial" custom-class="is-small">
										<b-input
											v-model="row.dt_inicio"
											type="date"
											class="input-date-picker"
											size="is-small"
										/>
									</b-field>
									<b-field label="Data Final" custom-class="is-small">
										<b-input
											v-model="row.dt_fim"
											type="date"
											class="input-date-picker"
											size="is-small"
										/>
									</b-field>
								</b-field>
							</div>
						</draggable>
					</div>
				</div>
			</div>
		</div>
		<div>
			<b-button style="margin-right: 10px" type="is-success" outlined @click="AdicionarProduto()">
				Adicionar Produto
			</b-button>
			<b-button type="is-danger" outlined> Cancelar </b-button>
		</div>
	</section>
</template>

<script>
import draggable from 'vuedraggable';
import Search from '../../layout/components/search';
import * as ecAxios from '../../util/ecAxios';
import global from '../../mixins/global';

export default {
	components: {
		Search,
		draggable,
	},
	mixins: [global],
	data() {
		return {
			options: [],
			initDateInput: [],
			endDateInput: [],
			checkedRows: [],
			order: [],
			data: [],
			columns: [
				{
					field: 'integracao_id',
					label: 'Código',
					width: '40',
					numeric: true,
				},
				{
					field: 'descricao',
					label: 'Nome do produto',
				},
				{
					field: 'ean',
					label: 'EAN',
				},
			],
		};
	},
	computed: {
		dragOptions() {
			return {
				animation: 200,
				group: 'description',
				disabled: false,
				ghostClass: 'ghost',
			};
		},
		myData() {
			return this.data;
		},
	},
	created() {
		this.getAllData();
	},
	methods: {
		async removeItem(item, index) {
			// eslint-disable-next-line no-alert
			const confirm = window.confirm(
				'Tem certeza que deseja excluir este item da lista de produtos?'
			);
			// eslint-disable-next-line no-useless-return
			if (!confirm) return;
			try {
				await ecAxios
					.connection()
					.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PRODUTOS_DESTAQUE}/delete`, {
						produto_id: item,
					});
				this.checkedRows.splice(index, 1);
				this.$buefy.notification.open({
					duration: 10000,
					message: 'O produto foi excluido com sucesso!',
					type: 'is-success',
				});
			} catch (err) {
				this.$buefy.notification.open({
					duration: 10000,
					message: 'Ocorreu um erro ao excluir o produto',
					type: 'is-danger',
				});
			}
		},
		async getAllData() {
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PRODUTOS_DESTAQUE}/showall`, {
					comp_produtoparam_id: this.$route.params.id,
					direction: 'desc',
					// limit: 50,
					offset: 0,
					orderby: 'dt_inicio',
					searchTerm: '',
				})
				.then((response) => {
					if (response.data.error === 0) {
						let newData = [];
						newData = response.data.produtos;
						const result = newData.map((item) => ({
							comp_produtoparam_id: item.comp_produtoparam_id,
							/* dt_inicio: format(new Date(item.dt_inicio), 'yyyy-MM-dd'),
							dt_fim: format(new Date(item.dt_fim), 'yyyy-MM-dd'), */
							integracao_id: item.integracao_id,
							status: item.status,
							descricao: item.descricao,
							produto_id: item.produto_id,
						}));
						this.checkedRows = result;
					}
				});
		},
		async searchtext(termo) {
			// eslint-disable-next-line no-param-reassign
			termo = termo.trim();
			let vetCodProduto = [];
			let vetEan = [];
			// eslint-disable-next-line camelcase
			let desc_produto = [];
			if (termo !== '') {
				// eslint-disable-next-line no-restricted-globals
				if (isNaN(termo)) {
					// eslint-disable-next-line camelcase
					desc_produto = termo.toLowerCase();
					// eslint-disable-next-line no-restricted-globals
				} else if (!isNaN(termo) && termo.length >= 10) {
					vetEan = termo;
				} else {
					vetCodProduto = termo;
				}
				await ecAxios
					.connection()
					.post(`${process.env.VUE_APP_API_ADM_EC}/produto/showall`, {
						cod_produto: vetCodProduto,
						ean: vetEan,
						searchterm: desc_produto,
						searchtype: 'init',
					})
					.then((response) => {
						if (response.data.error === 0) {
							this.data = response.data.produtos;
						}
					})
					.catch((e) => {
						this.$buefy.notification.open({
							message: `${e}`,
							type: 'is-danger',
						});
					});
			} else {
				this.data = [];
			}
		},
		async AdicionarProduto() {
			try {
				const data = {
					comp_produtoparam_id: this.$route.params.id,
					produtos: this.checkedRows,
				};

				await ecAxios
					.connection()
					.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PRODUTOS_DESTAQUE}`, data)
					.then((response) => {
						// eslint-disable-next-line no-unreachable
						if (response.data.error === 0) {
							this.$buefy.notification.open({
								duration: 10000,
								message: 'O produto foi adicionado com sucesso!',
								type: 'is-success',
							});
							if (window.history.length > 1) {
								this.$router.go(-1);
							} else {
								this.$router.push('/');
							}
						} else {
							this.loading = false;
							this.$buefy.notification.open({
								duration: 10000,
								message: response.data.message,
								type: 'is-danger',
							});
						}
					})
					.catch((e) => {
						this.$buefy.notification.open({
							duration: 5000,
							message: `${e}`,
							type: 'is-danger',
						});
					});
			} catch (error) {
				this.$buefy.notification.open({
					duration: 10000,
					message: 'Ocorreu um erro ao inserir o produto',
					type: 'is-danger',
				});
			}
		},
	},
};
</script>

<style scoped>
.title-pessoas {
	margin-bottom: 20px;
}
.container-tables {
	display: flex;
	width: 100%;
	flex-direction: row;
}
.table-box {
	width: 50%;
	padding: 10px;
}
.box-item-selected {
	padding: 10px;
	border-radius: 10px;
	border: 1px solid #cecece;
	margin-bottom: 10px;
}
.container-add-user {
	padding: 10px;
	background-color: #fff;
	margin-bottom: 15px;
}
.search-container {
	display: flex;
	justify-content: space-between;
	width: 100%;
	margin-bottom: 20px;
}
.container-table {
	display: flex;
	width: 100%;
	padding-top: 20px;
}
.pessoas-container {
	padding-bottom: 10px;
}
</style>

